module.exports = __webpack_public_path__ + "img/106ne.cbf83081.svg";